import React from 'react';
import { DragSource } from 'react-dnd';
import { FormattedMessage } from 'react-intl';
import { Button } from 'antd';

import ContentTypeIcon from 'components/ContentTypeIcon';
import { QUESTION_TYPES, CONTENT_TYPES } from 'shared/constants/survey';

import messages from './messages';
import './drag-to-add.less';

export const NODE_DND_TYPE = 'SurveyContent';

const dragSourceSpec = {
  beginDrag: (item) => {
    if (item.type === CONTENT_TYPES.BLOCK) {
      return {
        node: { active: true, block: { title: '' }, children: [] },
      };
    }
    if (item.type === CONTENT_TYPES.TEXT) {
      return {
        node: { active: true, text: { body: '' } },
      };
    }
    if (item.type === CONTENT_TYPES.PAGE_BREAK) {
      return {
        node: { pageBreak: true },
      };
    }
    // if (QUESTION_TYPES.includes(item.type))
    return {
      node: { active: true, question: { title: '', settings: { type: item.type } } },
    };
  },
};

const collect = connect => ({ connectDragSource: connect.dragSource() });

const DraggableItem = ({ connectDragSource, title, type }) => {
  const item = (
    <div className="drag__item">
      <ContentTypeIcon type={type} className="drag__item-icon" />
      <span className="drag__item-title">{title}</span>
    </div>
  );
  return connectDragSource(item, { dropEffect: 'copy' });
};

const Item = DragSource(NODE_DND_TYPE, dragSourceSpec, collect)(DraggableItem);

const DragToAddContent = ({ onImport }) => (
  <>
    <div className="drag__section">
      <div className="drag__section-title"><FormattedMessage {...messages.structure} /></div>
      <Item title={<FormattedMessage {...messages.block} />} type={CONTENT_TYPES.BLOCK} />
      <Item title={<FormattedMessage {...messages.pageBreak} />} type={CONTENT_TYPES.PAGE_BREAK} />
      <Item title={<FormattedMessage {...messages.text} />} type={CONTENT_TYPES.TEXT} />
    </div>
    <div className="drag__section">
      <div className="drag__section-title"><FormattedMessage {...messages.questionTypes} /></div>
      <Item title={<FormattedMessage {...messages.radio} />} type={QUESTION_TYPES.RADIO} />
      <Item title={<FormattedMessage {...messages.checkbox} />} type={QUESTION_TYPES.CHECKBOX} />
      <Item title={<FormattedMessage {...messages.field} />} type={QUESTION_TYPES.FIELD} />
      <Item title={<FormattedMessage {...messages.zipCode} />} type={QUESTION_TYPES.ZIP} />
      <Item title={<FormattedMessage {...messages.country} />} type={QUESTION_TYPES.COUNTRY} />
      <Item title={<FormattedMessage {...messages.contactMe} />} type={QUESTION_TYPES.CONTACT} />
      {/* <Item title={<FormattedMessage {...messages.nps} />} type={QUESTION_TYPES.NPS} /> */}
      <Item title={<FormattedMessage {...messages.sentiment} />} type={QUESTION_TYPES.SENTIMENT} />
      <Item title={<FormattedMessage {...messages.thumbs} />} type={QUESTION_TYPES.THUMBS} />
    </div>
    <div className="drag__section">
      <Button block onClick={onImport}><FormattedMessage {...messages.importContent} /></Button>
    </div>
  </>
);

export default DragToAddContent;
